import sanitizeHtml from 'sanitize-html';

/**
 * Sanitize html string to mitigate XSS attacks
 * Ref: https://www.npmjs.com/package/sanitize-html
 */

export default function sanitize(dirty, options = {}) {
  const cleaned = sanitizeHtml(dirty, options);
  return cleaned;
}
